import { render, staticRenderFns } from "./WidgetTimeOfDay.vue?vue&type=template&id=174bcdab&scoped=true&"
import script from "./WidgetTimeOfDay.vue?vue&type=script&lang=js&"
export * from "./WidgetTimeOfDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174bcdab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174bcdab')) {
      api.createRecord('174bcdab', component.options)
    } else {
      api.reload('174bcdab', component.options)
    }
    module.hot.accept("./WidgetTimeOfDay.vue?vue&type=template&id=174bcdab&scoped=true&", function () {
      api.rerender('174bcdab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/widgettimeofday/WidgetTimeOfDay.vue"
export default component.exports